import axios, { AxiosRequestConfig } from "axios";

type TRequest = AxiosRequestConfig & {
  url: string;
};

type TParam = string | number | boolean | Date;

class _ApiService {
  private async request<T>(config: TRequest): Promise<T> {
    const url = `${config.url}`;
    const authStorage = sessionStorage.getItem("auth-storage");

    const additionalHeaders: Record<string, string> = {};

    if (authStorage) {
      const authStorageState = JSON.parse(authStorage);
      const token = authStorageState?.state?.user?.tokens?.access_token;

      if (token) {
        additionalHeaders["authorization"] = `Bearer ${token}`;
      }
    }

    const restConfig = {
      ...config,
      url,
      data: config.params,
      headers: {
        ...config.headers,
        ...additionalHeaders,
      },
    };

    return axios(restConfig)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  }

  get<T>(url: string) {
    return this.request<T>({ method: "get", url });
  }

  post<T>(url: string, params: Record<string, TParam>) {
    return this.request<T>({ method: "post", url, params });
  }

  put<T>(url: string, params: Record<string, TParam>) {
    return this.request<T>({ method: "put", url, params });
  }

  patch<T>(url: string, params: Record<string, TParam>) {
    return this.request<T>({ method: "patch", url, params });
  }
}

export const ApiService = new _ApiService();
